import { icons } from "../../helpers/constants";

const DeviceSelectionRow = ({ selectable = true, selected, index, onClick, text, subtitle }) => {
    return (
        <div className={`d-flex flex-column w-100 ${index === -1 ? "bg-light-grey" : index % 2 === 0 ? "bg-white" : "bg-light-grey"}`}>
            <div className="d-flex align-items-center justify-content-between w-100 py-2 px-3" onClick={() => onClick()}>
                <div className="d-flex flex-column py-1 w-75">
                    <p className=" primary m-0 bold text-truncate">{text}</p>
                    <p className={`primary m-0 ${subtitle ? "" : "d-none"}`}>{subtitle}</p>
                </div>
                {selectable
                    ?
                    <div className={`${selected ? "bg-checked" : "bg-grey"} size_20 border-sm d-flex justify-content-center p-1 cursor-pointer`}>
                        {selected && <img className="white-icon" src={icons.check} alt={""} />}
                    </div>
                    :
                    <img className="cursor-pointer" src={icons.info_icon} alt={""} />
                }

            </div>
        </div>
    )
}

export default DeviceSelectionRow;